import { createFileRoute } from "@tanstack/react-router";
import FacetGlassesPage from "@/pages/FacetGlassesPage";
import { facetHead } from "@/lib/seo/facetHead";
import { facetLoader } from "@/lib/seo/facetLoader";
import { facetAliasRedirect } from "@/lib/seo/facetAliasRedirect";

export const Route = createFileRoute("/$country/glasses/$facet/$value")({
  beforeLoad: ({ params }) => facetAliasRedirect(params, "glasses"),
  component: FacetGlassesPage,
  loader: facetLoader,
  head: ({ params, loaderData }) => facetHead(params, loaderData),
});
